import { cn } from "@/shared/utils";
import { PropsWithChildren } from "react";

/**
 * @deprecated use one of the other empty state components instead for more possibilities!
 * @param children
 * @constructor
 */
export function EmptyState({ children, className }: Readonly<{ className?: string } & PropsWithChildren>) {
    return <p className={cn("text-s text-content-subtle", className)}>{children}</p>;
}

function Empty({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot="empty"
            className={cn("flex min-w-0 flex-1 flex-col items-center justify-center gap-8 text-center text-balance", className)}
            {...props}
        />
    );
}

function EmptyHeader({ className, ...props }: React.ComponentProps<"div">) {
    return <div data-slot="empty-header" className={cn("flex flex-col items-center gap-2 text-center", className)} {...props} />;
}

type EmptyImageProps = {
    variant?: "tracks" | "search";
    className?: string;
};
function EmptyImage({ variant = "tracks", className }: EmptyImageProps) {
    switch (variant) {
        case "search":
            return (
                <div className={cn("flex size-28 items-center justify-center", className)}>
                    <EmptySearch />
                </div>
            );
        case "tracks":
            return (
                <div className={cn("flex size-28 items-center justify-center", className)}>
                    <EmptyTracks />
                </div>
            );
    }
}

function EmptyTracks() {
    return (
        <svg width="96" height="93" viewBox="0 0 96 93" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41.7712 40L18.1208 92.8672H15.9275L18.9997 86H13.5232L13.3904 85.9902C12.7429 85.9038 12.3341 85.2088 12.6111 84.5898L16.2029 76.5898C16.3639 76.2322 16.7229 76.0013 17.115 76H23.4743L27.0525 68H21.5251L21.3923 67.9922C20.7442 67.9062 20.3354 67.2091 20.613 66.5898L23.3122 60.5898C23.4734 60.2324 23.8325 60.0014 24.2243 60H30.6326L34.2107 52H28.7556L28.6228 51.9922C27.9782 51.9071 27.5699 51.218 27.8396 50.5996L29.5896 46.5996C29.7288 46.2819 30.0228 46.0621 30.3591 46.0117L30.5056 46H36.8943L39.5779 40H41.7712ZM15.0681 84H19.8943L22.5798 78H17.7615L15.0681 84ZM23.072 66H27.947L29.7361 62H24.8708L23.072 66ZM30.2849 50H35.1052L35.9997 48H31.1599L30.2849 50Z"
                fillOpacity="0.55"
            />
            <path d="M22.4333 92.8672H20.2419L43.8904 40H46.0837L22.4333 92.8672Z" fillOpacity="0.55" />
            <path d="M76.1365 92.8672H73.9451L50.2947 40H52.488L76.1365 92.8672Z" fillOpacity="0.55" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M56.6638 40L59.3474 46H65.5212C65.9192 46.0006 66.281 46.2383 66.4392 46.6035L68.1677 50.6035C68.4522 51.2631 67.9679 51.9989 67.2497 52H62.031L65.6091 60H71.7322L71.8767 60.0098C72.2101 60.059 72.5029 60.2768 72.6443 60.5898L75.3435 66.5898C75.6404 67.2509 75.1559 67.9989 74.4314 68H69.1892L72.7673 76H78.8884L79.0349 76.0098C79.3692 76.0598 79.6621 76.279 79.8025 76.5938L83.3533 84.5938C83.6279 85.2133 83.2196 85.9055 82.572 85.9902L82.4392 86H77.2419L80.3142 92.8672H78.1208L54.4704 40H56.6638ZM76.3474 84H80.9021L78.238 78H73.6618L76.3474 84ZM68.2947 66H72.8845L71.0857 62H66.5056L68.2947 66ZM61.1365 50H65.7283L64.865 48H60.2419L61.1365 50Z"
                fillOpacity="0.55"
            />
            <path d="M68.8923 86H27.6833L28.5779 84H67.9978L68.8923 86Z" fillOpacity="0.55" />
            <path d="M65.3142 78H31.2615L32.1579 76H64.4177L65.3142 78Z" fillOpacity="0.55" />
            <path d="M60.8396 68H35.7361L36.6306 66H59.9451L60.8396 68Z" fillOpacity="0.55" />
            <path d="M58.156 62H38.4197L39.3142 60H57.2615L58.156 62Z" fillOpacity="0.55" />
            <path d="M53.6814 52H42.8943L43.7888 50H52.7868L53.6814 52Z" fillOpacity="0.55" />
            <path d="M51.8923 48H44.6833L45.5779 46H50.9978L51.8923 48Z" fillOpacity="0.55" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.9776 20C56.515 20.0001 63.7341 25.6304 66.131 33.3789C75.8675 33.7853 85.5201 34.5162 95.0782 35.5625C95.6272 35.6226 96.0241 36.116 95.964 36.665C95.9039 37.214 95.4094 37.6099 94.8605 37.5498C79.4653 35.8646 63.8231 35 47.9786 35C32.1384 35 16.4997 35.8645 1.1085 37.5488C0.559692 37.6086 0.0660264 37.2119 0.00596442 36.6631C-0.0538429 36.1143 0.342906 35.6207 0.891707 35.5605C10.4446 34.5151 20.0922 33.785 29.8233 33.3789C32.2201 25.6303 39.4402 20 47.9776 20ZM47.9776 22C40.591 22 34.3035 26.7126 31.9591 33.2959C37.2748 33.1003 42.6152 33 47.9786 33C53.3407 33 58.6799 33.1003 63.9942 33.2959C61.6496 26.7129 55.364 22.0001 47.9776 22Z"
                fillOpacity="0.55"
            />
            <path
                d="M20.5851 24.0947C20.8038 23.5877 21.3925 23.3538 21.8995 23.5723L30.6378 27.3408C30.2694 27.9017 29.9281 28.4821 29.6144 29.0791L21.1075 25.4092C20.6007 25.1904 20.3666 24.6017 20.5851 24.0947Z"
                fillOpacity="0.55"
            />
            <path
                d="M74.0558 23.5723C74.5627 23.3538 75.1505 23.5879 75.3692 24.0947C75.5879 24.6018 75.3548 25.1904 74.8478 25.4092L66.339 29.0791C66.0253 28.4821 65.684 27.9017 65.3155 27.3408L74.0558 23.5723Z"
                fillOpacity="0.55"
            />
            <path
                d="M30.3263 17.9854C30.7061 17.5845 31.3394 17.5676 31.7403 17.9473L35.881 21.8701C35.3336 22.2641 34.8065 22.6847 34.3009 23.1289L30.3644 19.3994C29.964 19.0197 29.947 18.3862 30.3263 17.9854Z"
                fillOpacity="0.55"
            />
            <path
                d="M64.215 17.9473C64.6157 17.5678 65.2482 17.5849 65.628 17.9854C66.0076 18.3863 65.9908 19.0196 65.59 19.3994L61.6525 23.1289C61.147 22.6848 60.6196 22.2649 60.0724 21.8711L64.215 17.9473Z"
                fillOpacity="0.55"
            />
            <path
                d="M58.1007 8.64062C58.3148 8.1321 58.9005 7.89394 59.4093 8.10742C59.9184 8.3215 60.1585 8.90788 59.9444 9.41699L55.7159 19.4707C55.099 19.2223 54.4671 19.0026 53.8224 18.8135L58.1007 8.64062Z"
                fillOpacity="0.55"
            />
            <path
                d="M36.545 8.10742C37.0539 7.89374 37.6404 8.13201 37.8546 8.64062L42.1319 18.8135C41.487 19.0027 40.8545 19.2212 40.2374 19.4697L36.0108 9.41699C35.7969 8.90816 36.0365 8.32175 36.545 8.10742Z"
                fillOpacity="0.55"
            />
            <path
                d="M47.9796 10C48.5318 10.0001 48.9796 10.4478 48.9796 11V18.002C48.6477 17.9862 48.3135 17.9775 47.9776 17.9775C47.6432 17.9775 47.3102 17.9863 46.9796 18.002V11C46.9796 10.4478 47.4274 10.0001 47.9796 10Z"
                fillOpacity="0.55"
            />
            <path
                d="M23.0441 10.9502C23.4326 10.5578 24.0667 10.5539 24.4591 10.9424L27.0128 13.4736C27.4051 13.8622 27.4081 14.4943 27.0196 14.8867C26.631 15.2789 25.9979 15.2821 25.6056 14.8936L23.0509 12.3633C22.6592 11.9747 22.656 11.3424 23.0441 10.9502Z"
                fillOpacity="0.55"
            />
            <path
                d="M71.4962 10.9424C71.8886 10.554 72.5227 10.558 72.9112 10.9502C73.2993 11.3424 73.2961 11.9747 72.9044 12.3633L70.3487 14.8936C69.9563 15.282 69.3233 15.279 68.9347 14.8867C68.5468 14.4944 68.5499 13.8621 68.9415 13.4736L71.4962 10.9424Z"
                fillOpacity="0.55"
            />
            <path
                d="M47.9796 0C48.5318 6.69154e-05 48.9796 0.447757 48.9796 1V5C48.9796 5.55224 48.5318 5.99993 47.9796 6C47.4274 5.99986 46.9796 5.5522 46.9796 5V1C46.9796 0.447799 47.4274 0.00013616 47.9796 0Z"
                fillOpacity="0.55"
            />
        </svg>
    );
}

function EmptySearch() {
    return (
        <svg width="84" height="84" viewBox="0 0 84 84" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.0586 21.0557C22.7071 19.4086 25.3795 19.4087 27.0283 21.0566L31.8994 25.9268L36.7734 21.0576C38.4224 19.4094 41.0955 19.4099 42.7441 21.0586L42.8936 21.2168C44.3895 22.8736 44.3416 25.4316 42.7441 27.0293L37.8711 31.8984L42.7441 36.7715L42.8936 36.9287C44.3426 38.5327 44.3415 40.9803 42.8936 42.584L42.7441 42.7422C41.0952 44.3911 38.4194 44.3911 36.7705 42.7422L31.8994 37.8711L27.0293 42.7422C25.432 44.3394 22.8733 44.3897 21.2158 42.8926L21.0576 42.7422C19.41 41.0937 19.4087 38.4206 21.0576 36.7715L25.9287 31.9004L21.0576 27.0293C19.409 25.3804 19.4098 22.7045 21.0586 21.0557ZM25.6152 22.4707C24.7476 21.6035 23.3405 21.6038 22.4727 22.4707C21.6048 23.3386 21.6048 24.7474 22.4727 25.6152L28.7578 31.9004L22.4727 38.1855L22.3193 38.3545C21.6078 39.2272 21.6595 40.5145 22.4727 41.3281C23.2864 42.1416 24.5735 42.1926 25.4463 41.4805L25.6152 41.3281L31.9004 35.043L38.1855 41.3281C38.9993 42.1416 40.2882 42.1926 41.1611 41.4805L41.3301 41.3281C42.1427 40.5146 42.1936 39.2271 41.4824 38.3545L41.3301 38.1855L35.043 31.8984L41.3301 25.6152C42.1432 24.8019 42.1936 23.5144 41.4824 22.6416L41.3301 22.4727C40.4623 21.6049 39.0554 21.605 38.1875 22.4727L31.9004 28.7559L25.6152 22.4707Z"
                fillOpacity="0.55"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 6C46.3594 6 58 17.6406 58 32C58 46.3594 46.3594 58 32 58C17.6406 58 6 46.3594 6 32C6 17.6406 17.6406 6 32 6ZM32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8Z"
                fillOpacity="0.55"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 0C49.6731 0 64 14.3269 64 32C64 39.3969 61.4878 46.2055 57.2734 51.625L61.8691 56.2188L63.2852 54.8066C64.0659 54.0265 65.3308 54.0262 66.1113 54.8066L81.6602 70.3516C84.7825 73.4736 84.7808 78.5363 81.6582 81.6582C78.6332 84.6819 73.7872 84.7763 70.6484 81.9414L70.3496 81.6582C70.325 81.6336 70.3016 81.6069 70.2773 81.582L54.8027 66.1133C54.0222 65.3329 54.0225 64.0657 54.8027 63.2852L56.2129 61.873L51.6191 57.2793C46.2007 61.4906 39.3939 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0ZM59.041 61.8711L59.043 61.873L57.6289 63.2871L57.627 63.2852L56.2168 64.6973L71.709 80.1855C71.7268 80.2039 71.743 80.2208 71.7539 80.2324C71.7633 80.2424 71.774 80.2542 71.7773 80.2578L71.7812 80.2617L71.9883 80.457C74.3419 82.582 77.9758 82.5111 80.2441 80.2441C82.5861 77.9027 82.5866 74.106 80.2461 71.7656L64.6973 56.2207L59.041 61.8711ZM32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2ZM55.9922 53.1719C55.1097 54.1711 54.1654 55.1139 53.166 55.9961L57.627 60.459L60.4551 57.6328L55.9922 53.1719Z"
                fillOpacity="0.55"
            />
        </svg>
    );
}

function EmptyTitle({ className, ...props }: React.ComponentProps<"div">) {
    return <div data-slot="empty-title" className={cn("leading-m text-xl font-medium", className)} {...props} />;
}

function EmptyDescription({ className, ...props }: React.ComponentProps<"p">) {
    return <p data-slot="empty-description" className={cn("text-content-subtle text-m leading-l font-normal", className)} {...props} />;
}

function EmptyContent({ className, ...props }: React.ComponentProps<"div">) {
    return <div data-slot="empty-content" className={cn("flex w-full max-w-sm min-w-0 flex-col items-center", className)} {...props} />;
}

export { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyImage, EmptyTitle };
